import { Template } from './template';
import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from '../../i18n/inspirationalTemplateMap.en';
import {
  isSupportedLanguage,
  INSPIRATIONAL_TEMPLATES_LANGUAGE_MAP,
} from '../../config';

export enum InspirationalTemplateAssetType {
  IMAGE = 'image',
  VIDEO = 'video',
}

interface InspirationalAsset {
  url: string;
  type: InspirationalTemplateAssetType;
}

export interface AdditionalFields {
  backgroundColor: string;
  features: string[];
  shortDescription: string;
  inspirationalAssets: InspirationalAsset[];
  inspirationalAssetsV2: InspirationalAsset[];
  thumbnailUrl: string;
}

export interface InspirationalTemplate extends Template, AdditionalFields {}

export function isInspirationalTemplate(
  template: Template,
): template is InspirationalTemplate {
  return EN_MAP[template.templateId!] !== undefined;
}

export function mapAmbassadorInspirationalTemplate(
  template: Template,
  language: string,
): InspirationalTemplate | null {
  const templateLanguage = isSupportedLanguage(language) ? language : 'en';
  const map = INSPIRATIONAL_TEMPLATES_LANGUAGE_MAP[templateLanguage];

  if (map[template.templateId!] === undefined) {
    return null;
  }
  return {
    ...template,
    ...map[template.templateId!],
  };
}
